import type { FxCashsState } from '../fxCashsModel';
import { combineReducers } from 'redux';
import { fxCashsStreamsReducer } from './fxCashsStreamsReducer';
import { fxCashsProductReducer } from './fxCashsProductReducer';

export const fxCashsReducer = combineReducers<FxCashsState>({
  streams: fxCashsStreamsReducer,
  cashs: fxCashsProductReducer,
});
